export default __webpack_public_path__ + "locales/bg/PrivacyPage.json?hash=06aacef96f83f1cb1e3106740c1f90d4";